module.exports = __webpack_public_path__ + "img/Ireland.e620d9fa.svg";